import { Routes, Route, HashRouter, Navigate } from "react-router-dom";
import React from "react";
import { PrimeReactProvider } from "primereact/api";
const Authentication = React.lazy(() => import("./pages/Authentication"));
const Beranda = React.lazy(() => import("./pages/Beranda"));
const AddItem = React.lazy(() => import("./pages/AddItem"));
const Keyplan = React.lazy(() => import("./pages/Keyplan"));
const UsersPage = React.lazy(() => import("./pages/users"));

function App() {
  return (
    <div className="h-screen bg-gray-50">
      <PrimeReactProvider>
        <HashRouter>
          <Routes>
            <Route path="/" name="Login Page" element={<Authentication />}></Route>
            <Route exact path="/beranda" name="Dashboard" element={<Beranda />}></Route>
            <Route exact path="/addItem" name="Add Item" element={<AddItem />}></Route>
            <Route exact path="/keyplan" name="Keyplan" element={<Keyplan />}></Route>
            <Route exact path="/users" name="User" element={<UsersPage />}></Route>
          </Routes>
        </HashRouter>
      </PrimeReactProvider>
    </div>
  );
}

export default App;
